import { Pipe, PipeTransform } from '@angular/core';
import { formatCompactCurrency } from './compact-currency.helper';

/** `{{ amount | compactCurrency }}` → `$865K`, `$1.42M`, `$0`; empty string for a missing value. */
@Pipe({
  name: 'compactCurrency',
  standalone: false,
})
export class CompactCurrencyPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    return formatCompactCurrency(value);
  }
}
